import { Row } from "antd";
import CopyToClipboard from "react-copy-to-clipboard";
import SyntaxHighlighter from "react-syntax-highlighter";
import { docco } from "react-syntax-highlighter/dist/esm/styles/hljs";

interface Props {
  code: string;
}
export default function CodeSyntaxHighlighter({ code }: Props) {
  return (
    <Row
      style={{ position: "relative", width: "100%" }}
      className="box-embed syntax-highlight"
      gutter={[0, 12]}
    >
      <SyntaxHighlighter language="html" style={docco}>
        {code}
      </SyntaxHighlighter>
      <CopyToClipboard text={code}>
        <img
          style={{
            cursor: "pointer",
            position: "absolute",
            top: 16,
            right: 16,
          }}
          src="icon/copy.svg"
          alt="copy"
        />
      </CopyToClipboard>
    </Row>
  );
}
